import styled from 'styled-components';

export const Container: any = styled.div`
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: space-between;
    position: relative;
    width: 65px;
`;

export const ContainerInline: any = styled.div`
    position: relative;
    padding: 0;
    margin: 0 0 12px 0;
    display: flex;
    justify-content: space-between;
    width: 126px;
    ul{
        right: -50px;
    }
`;
export const Info: any = styled.span`
    display: inline-block;
    margin-left: 10px;
    margin-top: 10px;
    font-size: 1rem;
    color: #8C8C8C
`
export const FloatingIcon: any = styled.i`
    font-size: 15px;
    height: 15px;
    width: 15px;
    color: #1E638E;
    position: absolute;
    right: 10px;
    top: 15px;
`;
export const Icon: any = styled.button`
    border: 0;
    margin: 0;
    background: transparent;

    &:focus {
        outline: none;
    }

    i {
        font-size: 25px;
        height: 30px;
        width: 30px;
        color: #5E6167;
        transition: .2s ease-in-out;

        &:hover {
            color: black;
            transition: .2s ease-in-out;
        }
    }
`;
export const Error: any = styled.span`
    color: red;
    position: absolute;
    left: 30px;
`;
export const Count: any = styled.span`
    cursor: pointer;
    border: 0;
    display: inline-block;
    background: red;
    font-size: .9rem;
    color: white;
    padding: 1px 8px;
    height: 20px;
    position: absolute;
    border-radius: 50%;
    left: 25px;

    &:focus {
        outline: none;
    }
    i {
        font-size: 25px;
        height: 30px;
        width: 30px;
        color: lightgray;
        transition: .2s ease-in-out;

        &:hover {
            color: black;
            transition: .2s ease-in-out;
        }
    }
`;
export const UlContainer: any = styled.ul`
    height: auto;
    width: 300px;
    position: absolute;
    z-index: 9999;
    top: 42px;
    right: -50px;
    border: 0;
    padding: 0;
    background: rgb(255, 255, 255);
    box-shadow: 1px 0 0 0px rgb(207, 210, 214);

    &:before{
        content: '';
        width: 15px;
        height: 15px;
        z-index: -1;
        background-color: white;
        display: inline-block;
        border: 1px solid rgb(255, 255, 255);
        border-bottom: none;
        border-right: none;
        position: absolute;
        top: -6px;
        right: 85px;
        transform: rotateZ(-45deg);
    }
    &:focus {
        outline: none;
    }
    li.link{
        cursor: pointer;
        width: inherit;
        transition: .2s ease-in-out;
        &:hover{
            background-color: #e2e2e2;
            span{
                color:#1E638E
            }
        }
        span{
            display: inline-block
            max-width: 260px;
        }
    }

    li {
        position: relative;
        margin: 0!important;
        list-style: none;
        font-size: 16px;
        padding: 5px 10px;
        border-bottom: 1px solid rgb(207, 210, 214);
        p{
            padding: 5px 0 0 0;
            margin: 0;
            color: #7b7575
            font-size: .75rem
        }
        &.last-child{
            text-align:center;
            background-color: #e7e9ea;
            bottom: 0;
            padding: 1rem;
            width: 100%;
            height: 4rem;
            border-top: 0.0625rem solid #bfc0c2;
        }
    }
`;
export const DisplayMsg: any = styled.span`
    border: 0;
    display: inline-block;
    background: white;
    color: #5E6167;
    position: absolute;
    padding: 5px;
    width: 200px;
    top: 45px;
    left: 8px;
    box-shadow: 0 0 0 1px rgb(207, 210, 214);
    &:before{
        content: '';
        width: 15px;
        height: 15px;
        background-color: white;
        display: inline-block;
        border: 1px solid rgb(207, 210, 214);
        border-bottom: none;
        border-left: none;
        position: absolute;
        top: -8px;
        left: 8px;
        transform: rotateZ(-45deg);
    }
`;